import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import SmsConfigurationAPI from '../../api/SmsConfigurationAPI';
import Display from '../../util/Display';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import Const from '../../util/Constants';

class SmsConfigurationList extends React.Component {

  constructor(props) {
    super(props);
    this.emailconfigs = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;
    this.list = { ...this.list, pagination: { currentPage: 1, pageCount: 1, perPage: 10 } };

    const model = reactLocalStorage.getObject(Const.Model).sms_config;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) SmsConfigurationAPI.list(this.list, this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => { this.smsconfigs = res; this.setState({ inApiCall: false }); };

  vewDoc = async id => {
  };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to Delete this Configuration?`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SmsConfigurationAPI.delete(index, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Configuration Deleted successfully', 'success');
    SmsConfigurationAPI.list(this.list, this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const templatesUI = this.smsconfigs && this.smsconfigs.map((template, _i) => (
      <tr key={`templates_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{template.name}</td>
        <td>{template.link}</td>
        <td>{template.body}</td>
        <td>{template.method}</td>
        <td>{template.is_default === Const.True ? 'Yes' : 'No'}</td>
        <td>{Display.ModelLabelValue('user', template.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(template.created_date)}</td>
        <td>{Display.ModelLabelValue('user', template.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(template.updated_date)}</td>
        <td>
          {this.Update &&
            <NavLink to={`${this.path}/add-edit/${template.id}`} className="buttons update">
              <FaPencilAlt /> Update
            </NavLink>
          }
          {template.status !== Const.AlwaysActive && this.Delete &&
            <span onClick={() => this.confirmDelete(template.id)} className="buttons delete">
              <FaTrash /> Delete
            </span>
          }
        </td>
      </tr>
    ));

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 pb-3"><h3>SMS Configurations List</h3></div>
            {this.Add &&
              <div className="col-md-6 text-right pb-3">
                <NavLink to={`${this.path}/add-edit/0`} className="buttons success">
                  + Add SMS Configuration</NavLink>
              </div>
            }

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Link</th>
                    <th>Body</th>
                    <th>Method</th>
                    <th>Default</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{templatesUI}</tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(SmsConfigurationList);
